export const areaTypeRoutes = {
	areaTypes: (query?: string) => `/booth-types/${query ? `?${query}` : ''}`,
	areaType: (id: string) => `/booth-types/${id}/`,
	areaTypeHistory: (id: string) => `/booth-types/${id}/history/`,
	areaTypeBulkDelete: '/booth-types/bulk_delete/'
} as const
